import React from 'react';
import Fade from '@material-ui/core/Fade';
import Base, { CopyContainer, FADE_TIMEOUT, H2, Icon, ImgContainer, P, Root } from '../Base';

class PreventativeCarePaysOff extends Base {
  static isVisible = () => true;

  icon = '/images/insurance_tutorial/04_preventative.svg';

  render = () => {
    return (
      <Fade in timeout={FADE_TIMEOUT}>
        <Root>
          <ImgContainer>
            <Icon src={this.icon} />
          </ImgContainer>

          <CopyContainer>
            <H2>Preventative care pays off</H2>

            <P>
              If you think about it, it’s actually in your insurance provider's best interest for{' '}
              you to stay healthy. That’s why they make some preventative services available for{' '}
              little to no cost.
            </P>

            <P>
              Case in point: your plan includes a <b>free annual physical</b>.
            </P>
          </CopyContainer>
        </Root>
      </Fade>
    );
  };
}

export default PreventativeCarePaysOff;
